module.exports = __webpack_public_path__ + "img/sampleQRcode.cba00ff8.png";